// Polyfills
import 'intersection-observer';

interface IcreateObserverOptions {
	observedSelector: string;
	ancestorSelector?: string;
	options: IntersectionObserverInit;
	intersectionRatio?: number;
}

export default class SiteAnimations {
	private createObserver(opts: IcreateObserverOptions): void {
		const observerElements: NodeList = document.querySelectorAll(opts.observedSelector);
		if (observerElements.length == 0) {
			return;
		}
		let getParentElement = this.getParentElement;
		const callback = function (entries: Array<IntersectionObserverEntry>, observer: IntersectionObserver) {
			entries.forEach((entry) => {
				if (entry.isIntersecting && entry.intersectionRatio >= (opts.intersectionRatio || 0)) {
					const element = entry.target;
					const ancestor = !!opts.ancestorSelector ? getParentElement(element, opts.ancestorSelector) : element;
					observer.unobserve(element);

					/* resolves jank */
					window.requestAnimationFrame(() => {
						ancestor.setAttribute('data-animation', 'begin');
					});
				}
			});
		};
		const observer: IntersectionObserver = new IntersectionObserver(callback, opts.options);

		for (let i = 0, l = observerElements.length; i < l; ++i) {
			let element = observerElements[i] as HTMLElement;

			const ancestor = !!opts.ancestorSelector ? this.getParentElement(element, opts.ancestorSelector) : element;
			ancestor.setAttribute('data-animation', 'setup');
			observer.observe(element);
		}
	}
	private getParentElement(decendantElement: Element, ancestorSelector: string): Element {
		let ancestors: NodeList = document.querySelectorAll(ancestorSelector);
		let ancestor: Element = decendantElement;

		for (let i = 0, l = ancestors.length; i < l; ++i) {
			let element = ancestors[i] as Element;
			if (element.contains(decendantElement)) {
				ancestor = element as Element;
			}
		}
		return ancestor;
	}
	constructor(items: IcreateObserverOptions[]) {
		items.forEach((item) => {
			this.createObserver(item);
		});
	}
}
